import { render, staticRenderFns } from "./detail_regular.vue?vue&type=template&id=6870446c&scoped=true&"
import script from "./detail_regular.vue?vue&type=script&lang=js&"
export * from "./detail_regular.vue?vue&type=script&lang=js&"
import style0 from "./detail_regular.vue?vue&type=style&index=0&id=6870446c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870446c",
  null
  
)

export default component.exports